import Icon from "../../components/Icon";
import LoadingBlock from "../../components/LoadingBlock";
import EmptyState from "../../components/EmptyState";
import Pagination from "../../components/Pagination";
import { useApi } from "../../hooks/useApi";
import { useRefresh } from "../../contexts/RefreshContext";
import { getNotifications, markAllRead, markRead } from "../../api/notificationService";
import { useState } from "react";
import { fromNow } from "../../utils/formatters";
import { showApiError, showToast } from "../../utils/toast";

export default function NotificationsPage() {
  const { refreshKey } = useRefresh();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const notifs = useApi(
    () => getNotifications({ page, per_page: perPage }),
    [refreshKey, page, perPage],
  );
  const list = notifs.data?.notifications?.data || [];
  const meta = notifs.data?.notifications
    ? {
        current_page: notifs.data.notifications.current_page,
        last_page: notifs.data.notifications.last_page,
        from: notifs.data.notifications.from,
        to: notifs.data.notifications.to,
        total: notifs.data.notifications.total,
        per_page: notifs.data.notifications.per_page,
      }
    : null;
  const unread = notifs.data?.unread_count || 0;

  const onMarkAll = async () => {
    try {
      await markAllRead();
      showToast("success", "Marked all read");
      notifs.reload();
    } catch (err) { showApiError(err); }
  };

  const onMark = async (id) => {
    try {
      await markRead(id);
      notifs.reload();
    } catch (err) { showApiError(err); }
  };

  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">Activity</h1>
          <div className="page-sub">{unread} unread · all notifications and system events</div>
        </div>
        <div className="page-actions">
          <button className="btn btn-secondary" onClick={onMarkAll} disabled={unread === 0}>Mark all read</button>
        </div>
      </div>

      <div className="card">
        <div className="card-body no-pad">
          {notifs.loading ? (
            <div style={{ padding: 16 }}><LoadingBlock rows={6} /></div>
          ) : list.length === 0 ? (
            <EmptyState icon="bell" title="No notifications" hint="You're all caught up." />
          ) : (
            list.map((n, i) => (
              <div
                key={n.id}
                style={{
                  padding: "14px 18px",
                  borderTop: i > 0 ? "1px solid var(--border)" : "none",
                  display: "flex",
                  gap: 12,
                  alignItems: "flex-start",
                  background: n.read_at ? "transparent" : "var(--primary-50)",
                  cursor: n.read_at ? "default" : "pointer",
                }}
                onClick={() => !n.read_at && onMark(n.id)}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 999,
                    background: "var(--primary-100)",
                    color: "var(--primary-700)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="bell" size={14} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="t-primary text-sm fw-500">{n.data?.title || "Notification"}</div>
                  <div className="t-muted text-xs" style={{ marginTop: 2, overflowWrap: "anywhere" }}>{n.data?.message}</div>
                </div>
                <div className="t-muted text-xs">{fromNow(n.created_at)}</div>
              </div>
            ))
          )}
        </div>
        <Pagination
          meta={meta}
          page={page}
          onPageChange={setPage}
          perPage={perPage}
          onPerPageChange={setPerPage}
          disabled={notifs.loading}
        />
      </div>
    </>
  );
}
